<template>
  <div>
    <!-- <div class="openplayer" v-if="!this.$store.state.player.playerDisplay" @click="openplayer()">A</div> -->
    <!-- <div class="player" :class="[ this.$store.state.player.playerDisplay ? 'open' : 'close' ,ize ? 'minize':'maxize' ]"> -->
    <div class="player" v-show="this.$store.state.player.playerDisplay" :class="[ this.$store.state.player.ize ? 'maxize':'minize' ]">
      <div :class="`${classes}-wrapper`">
        <div :class="`${classes}__player`">
          <!-- <a @click="stop()" title="Stop" class="icon-stop2"></a> -->
          <div class="minify">
            <a @click="pause()" title="Play" class="playMin" :class="[ paused ? 'icon-player' : 'icon-pa' ]"></a>
            <div class="imging">
              <img :src="this.$store.state.player.imgUrl" alt="">
              <a @click="pause()" title="Play" class="play" :class="[ paused ? 'icon-player' : 'icon-pa' ]"></a>
            </div>
          </div>
          <div class="timedp">
            <router-link :to="this.$store.state.player.toUrl" class="voicename">{{$store.state.player.voiceName}}</router-link>
            <span :class="`${classes}__playback-time-current`">{{currentTime}}</span>
            <span :class="`${classes}__playback-time-separator`"></span>
            <span :class="`${classes}__playback-time-total`">{{duration}}</span>
            <div v-on:click="setPosition" :class="`${classes}__playback-time-wrapper`" title="Time played : Total time">
              <div v-bind:style="progressStyle" :class="`${classes}__playback-time-indicator`"></div>
            </div>
            <a @click="changeLoop()" class="loop" :class="[ innerLoop ? 'icon-loop2' : 'icon-spinner11']"></a>
            <a class="ize" :class="[isMinize ? 'icon-s5-572' : 'icon-s5-542' ]" v-on:click="minize()"></a>
            <div :class="`${classes}__extern-wrapper`">
              <!-- <a @click="download()" class="icon-download"></a> -->
              <a @click="mute()" :class="[isMuted ? 'icon-volume-mute2' : 'icon-volume-high' ]" title="Mute"></a>
              <!-- <a @click="mute()" :class="[isMuted ? 'icon-volume-mute2': 'icon-volume-low' ]" title="Mute"></a> -->
              <!-- <input orient="vertical" v-model.lazy="volumeValue" v-on:change="updateVolume()" type="range" min="0" max="100" class="volume-slider" /> -->
              <!-- <a @click="muteMax()" class="icon-volume-high" title="Mute"></a> -->
              <!-- <a v-on:mouseover="toggleVolume()" class="volume-toggle icon-paragraph-justify" title="Volume">
            <input orient="vertical" v-model.lazy="volumeValue" v-on:change="updateVolume()" v-show="hideVolumeSlider" type="range" min="0" max="100" class="volume-slider" />
          </a> -->
            </div>
          </div>
          <div class="minify">
            <a @click="mute()" title="Mute" class="playMin mute" :class="[isMuted ? 'icon-volume-mute2' : 'icon-volume-high' ]"></a>
            <!-- <a class="ize playMin" :class="[isMinize ? 'icon-s5-542': 'icon-s5-572' ]" v-on:click="minize()"></a> -->
          </div>
        </div>
        <!-- <audio class="audioget" v-bind:id="playerId" :loop="innerLoop" :src="this.$store.state.player.playUrl" ref="audiofile" preload="auto" style="display:none;"></audio> -->
        <!-- <audio controls="controls" class="audioget" v-bind:id="playerId" :loop="innerLoop" ref="audiofile"></audio> -->
        <audio class="audioget" v-bind:id="playerId" :loop="innerLoop" ref="audiofile"></audio>
      </div>
    </div>
  </div>
</template>

<!-- <script src="@/player.js"></script>-->
<script>
export const baseVolumeValue = 7.5
let audio, uuid

export const prefixCls = 'vue-sound'

export const generateUUID = () => {
  return 'xxxxxxxx-xxxx-4xxx'.replace(/[xy]/g, function(c) {
    let v, r
    r = (Math.random() * 16) | 0
    v = c === 'x' ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })
}

export const convertTimeHHMMSS = val => {
  let hhmmss = new Date(val * 1000).toISOString().substr(11, 8)
  return hhmmss.indexOf('00:') === 0 ? hhmmss.substr(3) : hhmmss
}

export default {
  name: 'vue-audio',
  props: {
    file: {
      type: String,
      default: null
    },
    autoPlay: {
      type: Boolean,
      default: true
      // default: false
    },
    loop: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    duration: function() {
      return this.audio ? convertTimeHHMMSS(this.totalDuration) : ''
    },
    playerId: function() {
      return 'player-' + this.uuid
    },
    classes: function() {
      return prefixCls
    }
  },
  data() {
    return {
      // voiceName: this.$store.state.player.voiceName,
      close: true,
      isMinize: false,
      isMuted: false,
      loaded: false,
      playing: false,
      paused: true,
      progressStyle: '',
      currentTime: '00:00',
      uuid: '0',
      innerLoop: undefined,
      audio: undefined,
      totalDuration: 0,
      hideVolumeSlider: false,
      volumeValue: baseVolumeValue,
      unsub: '',
      playnow: false
    }
  },
  watch: {},
  created() {
    if (this.$store.state.player.loaded) {
      this.$store.state.player.playerDisplay = true
    } else {
      this.$store.state.player.playerDisplay = false
    }
  },
  methods: {
    setPosition: function name(e) {
      let tag = e.target
      if (this.paused) return

      if (e.target.tagName === 'SPAN') {
        return
      }
      const pos = tag.getBoundingClientRect()
      const seekPos = (e.clientX - pos.left) / pos.width
      this.audio.currentTime = parseInt(this.audio.duration * seekPos)
    },
    updateVolume: function() {
      this.hideVolumeSlider = false
      this.audio.volume = this.volumeValue / 100
      if (this.volumeValue / 100 > 0) {
        this.isMuted = this.audio.muted = false
      }

      if (this.volumeValue / 100 === 0) {
        this.isMuted = this.audio.muted = true
      }
    },
    toggleVolume: function() {
      this.hideVolumeSlider = true
    },
    stop: function() {
      this.playing = false
      this.paused = true
      this.audio.pause()
      this.audio.currentTime = 0
    },
    play: function() {
      if (this.playing && !this.paused) return
      this.paused = false
      this.audio.play()
      this.playing = true
    },
    pause: function() {
      this.paused = !this.paused
      this.paused ? this.audio.pause() : this.audio.play()
      this.$store.state.player.playnow = !this.paused
    },
    changeLoop: function() {
      this.innerLoop = !this.innerLoop
    },
    download: function() {
      this.stop()
      window.open(this.file, 'download')
    },
    minize: function() {
      this.isMinize = !this.isMinize
      this.$store.state.player.ize = !this.$store.state.player.ize
    },
    mute: function() {
      this.isMuted = !this.isMuted
      this.audio.muted = this.isMuted
      this.volumeValue = this.isMuted ? 0 : 75
    },
    muteMax: function() {
      this.isMuted = false
      this.audio.muted = this.isMuted
      this.volumeValue = this.isMuted ? 100 : 100
    },
    _handleLoaded: function() {
      if (this.audio.readyState >= 2) {
        if (this.autoPlay) this.play()

        this.loaded = true
        this.totalDuration = parseInt(this.audio.duration)
      } else {
        throw new Error('Failed to load sound file')
      }
    },
    _handlePlayingUI: function(e) {
      let currTime = parseInt(this.audio.currentTime)
      let percentage = parseInt(currTime / this.totalDuration * 100)
      this.progressStyle = `width:${percentage}%;`
      this.currentTime = convertTimeHHMMSS(currTime)
    },
    _handlePlayPause: function(e) {
      if (e.type === 'pause' && this.playing === false) {
        // this.progressStyle = `width:0%;`
        // this.currentTime = '00:00'
        this.paused = true
      }
    },
    init: function() {
      this.audio.addEventListener('timeupdate', this._handlePlayingUI)
      this.audio.addEventListener('loadeddata', this._handleLoaded)
      this.audio.addEventListener('pause', this._handlePlayPause)
      this.audio.addEventListener('play', this._handlePlayPause)
    },
    getAudio: function() {
      return this.$el.querySelectorAll('audio')[0]
    },
    playNow: function() {
      this.paused = true
      this.pause()
    },
    asyncSetUrl: function() {
      this.audio.src = this.$store.state.player.playUrl
    },
    openplayer() {
      this.$store.state.player.playerDisplay = true
    }
  },
  mounted: function() {
    this.uuid = generateUUID()
    this.audio = this.getAudio()
    this.innerLoop = this.loop
    this.init()
    this.unsub = this.$store.subscribe((mutation, state) => {
      // console.log(this.audio.duration)
      if (mutation.type === 'CHANGE_PLAY_URL') {
        this.openplayer()
        this.asyncSetUrl()
        setTimeout(() => {
          this.playNow()
        }, 100)
        // this.isMuted = true
        // this.volumeValue = 10
        // console.log(mutation.type)
      }
      if (mutation.type === 'CHANGE_PAUSE') {
        // console.log(mutation.type)
        // this.isMuted = true
        // this.volumeValue = 100
        this.pause()
      }
    })
  },
  beforeDestroy: function() {
    this.audio.removeEventListener('timeupdate', this._handlePlayingUI)
    this.audio.removeEventListener('loadeddata', this._handleLoaded)
    this.audio.removeEventListener('pause', this._handlePlayPause)
    this.audio.removeEventListener('play', this._handlePlayPause)
    this.unsub()
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/ly.scss';
@import '@/assets/scss/color.scss';

$prefixCls: 'vue-sound';
.openplayer {
  position: fixed;
  bottom: 64px;
  width: 100%;
  padding: 8px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  font-size: 1rem;
  z-index: 2;
  border-radius: 5px;
}
.player {
  position: fixed;
  bottom: 64px;
  width: 100%;
  padding: 18px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  font-size: 1rem;
  z-index: 2;
  border-radius: 5px;
  &.close {
    display: none;
  }
  &.open {
    display: flex;
  }
  a {
    transition: all 0.3s;
    color: rgba(255, 255, 255, 0.55);
    &.play {
      &.icon-player,
      &.icon-pa {
        &::after {
          transition: all 0.3s;
        }
      }
    }
  }
  a:hover {
    color: #fff !important;
    &.play {
      &.icon-player,
      &.icon-pa {
        &::after {
          border: 1px solid rgba(255, 230, 206, 0.734) !important;
        }
      }
    }
  }
  .vue-sound__playback-time-wrapper:hover {
    background-color: rgba(255, 255, 255, 0.3) !important;
  }
  .vue-sound-wrapper {
    width: 100%;
    padding: 8px;
    background-image: url('./../assets/img/chiilih-rep-bk.png');
    background-size: 100px 100px;
    background-color: rgba(191, 172, 123, 0.88);
    border: 1px solid rgba(255, 230, 206, 0.734);
    border-radius: 12px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    box-shadow: 0 0 18px 0px rgba(179, 162, 133, 0.7);
    // height: 88px;
    height: auto;
    transition: all 0.3s;
    .vue-sound__player {
      position: relative;
      display: inline-flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      .loop {
        color: rgba(255, 255, 255, 0.55);
      }
      .minify {
        display: inline-flex;
        justify-content: center;
        align-items: center;
        // margin-right: 8px;
        .playMin {
          width: 40px;
          height: 24px;
          color: #fff;
          display: none;
          justify-content: center;
          align-items: center;
          &::before {
            font-size: 3rem !important;
          }
          &.mute {
            // font-size: 1rem !important;
            margin-right: 26px;
            &::before {
              font-size: 1.3rem !important;
            }
          }
          &::before {
            font-size: 3.6rem;
          }
        }
        .imging {
          position: relative;
          display: block;
          width: 72px;
          height: 72px;
          overflow: hidden;
          border-radius: 5%;
          color: rgba(255, 255, 255, 0.55);
          box-shadow: 0 0 0 1px #fff;
          opacity: 1;
          transition: all 0.3s;
          img {
            position: relative;
            width: 100%;
          }
          .play {
            position: absolute;
            font-size: 3.6rem;
            top: 4px;
            left: 4px;
            width: 64px;
            height: 64px;
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            align-items: center;
            color: #fff;
            z-index: 1;
            &::before {
              // text-shadow: 1px 1px 12px rgb(90, 0, 0);
              z-index: 2;
            }
            &::after {
              content: '';
              position: absolute;
              padding: 0;
              margin: 0;
              left: 8px;
              z-index: 1;
              width: 46px;
              height: 46px;
              border-radius: 50%;
              display: block;
              background-color: rgba(191, 172, 123, 0.88);
              border: 1px solid rgba(255, 230, 206, 0.734);
              box-shadow: 0 0 25px 0px rgba(58, 40, 0, 0.37);
            }
          }
        }
        .vue-sound__extern-wrapper {
          display: block;
          width: 100%;
          display: inline-flex;
          flex-wrap: wrap;
          justify-content: center;
          align-items: center;
          justify-content: space-between;
        }
      }
      .timedp {
        display: block;
        width: 100%;
        display: inline-flex;
        flex-wrap: wrap;
        justify-content: center;
        align-items: center;
        justify-content: space-between;
        color: rgba(255, 255, 255, 0.77);
        margin: 0 0 0 8px;
        a.voicename {
          width: 100%;
          display: block;
          padding: 3px 20px 3px 0;
          margin: 0;
          color: #fff;
        }
        .ize {
          position: absolute;
          right: 0;
          // top: 2px;
          font-size: 1.3rem;
        }
        & > span {
          font-size: 0.7rem;
          padding: 0 3px;
          margin: 0 0 -18px 0;
          font-weight: 300;
          letter-spacing: 2px;
        }
        .vue-sound__playback-time-wrapper {
          position: relative;
          display: block;
          margin: 0;
          height: 18px;
          width: 100%;
          background-color: rgba(255, 255, 255, 0.2);
          margin: 0 0 6px 0;
          transition: width 1.3s;
          .vue-sound__playback-time-indicator {
            background-color: rgb(218, 0, 0);
            position: absolute;
            left: 0;
            height: 3px;
            bottom: 0;
            transition: width 1.3s;
          }
        }
        .vue-sound__extern-wrapper {
          display: inline-flex;
          flex-wrap: wrap;
          justify-content: center;
          align-items: center;
          justify-content: space-between;
          position: relative;
          height: 18px;
          padding: 0 18px;
          a {
            position: absolute;
            display: flex;
            justify-content: center;
            align-items: center;
            width: 18px;
            height: 18px;
            top: 0;
          }
          .icon-volume-mute2,
          .icon-volume-low {
            // left: 5px;
            text-align: right;
          }
          a.icon-volume-mute2 {
            color: $red !important;
            &:hover,
            &:active {
              color: $red !important;
            }
          }
          .icon-volume-high {
            right: 0;
          }
          .volume-slider {
            margin: 0 5px;
            width: 100%;
            opacity: 0.6;
          }
          // input[type='range'] {
          //   color: #000;
          //   background-color: #fff;
          // }
        }
      }
    }
  }
}
.maxize {
  .vue-sound-wrapper {
    height: auto !important;
    transition: all 0.3s;
  }
  .playMin {
    display: none !important;
  }
  .imging {
    display: block !important;
    opacity: 1 !important;
    transition: all 0.3s;
  }
  .timedp {
    span,
    .loop {
      display: inherit !important;
    }
    .vue-sound__playback-time-wrapper {
      height: 18px !important;
    }
    .vue-sound__extern-wrapper {
      display: inline-flex !important;
    }
    .ize {
      top: 0px !important;
    }
  }
}
.minize {
  padding: 0;
  bottom: 64px;
  .vue-sound-wrapper {
    // height: 55px !important;
    border-radius: 0;
    padding: 3px;
    transition: all 0.3s;
  }
  .playMin {
    display: inline-flex !important;
  }
  .imging {
    opacity: 0 !important;
    display: none !important;
    transition: all 0.3s;
  }
  .timedp {
    span,
    .loop {
      display: none !important;
    }
    .vue-sound__playback-time-wrapper {
      height: 3px !important;
    }
    .vue-sound__extern-wrapper {
      display: none !important;
    }
  }
}
_::-webkit-full-page-media,
_:future,
:root .player .vue-sound-wrapper {
  background-color: rgba(191, 172, 123, 0.8);
  -webkit-backdrop-filter: blur(10px);
}
_::-webkit-full-page-media,
_:future,
:root
  .player
  .vue-sound-wrapper
  .vue-sound__player
  .minify
  .imging
  .play::after {
  background-color: rgba(191, 172, 123, 0.5);
  background-color: rgba(191, 172, 123, 0.33);
  -webkit-backdrop-filter: blur(12px);
}
</style>



// WEBPACK FOOTER //
// src/components/player.vue